export default __webpack_public_path__ + "2d879daa0fbf8cb0122dfa0e5996b8ca.jpeg";